<template>
    <transition name="fade">
        <div id="documentation">
            <button>Voir maintenant →</button>
            <button @click="emitGoPlan">Voir plus tard →</button>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'Documentation',
        methods: {
            emitGoPlan() {
                this.$emit('go')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/css/default";

    #documentation {
        position: absolute;
        width: 100%;
        bottom: 5%;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 5;
        button {
            border: 3px solid white;
            background-color: transparent;
            color: white;
            padding: 20px 40px;
            border-radius: 50px;
            min-width: 230px;
            font-size: 1.5rem;
            font-weight: bold;
            transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
            cursor: pointer;
            outline: none;
            overflow: hidden;
            position: relative;
            margin: 20px;
            &:hover {
                background-color: $blue;
                border: 3px solid transparent;
                color: #fff;
            }
        }
    }
</style>